<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TopoFullscreen',
})
</script>
<template>
    <div class="topo-fullscreen">
        <TopoRender />
    </div>
</template>
<script setup lang="ts" name="TopoFullscreen">
import TopoRender from '@/components/Topo/topo/TopoRender.vue'
</script>

<style lang="scss">
    .topo-fullscreen {
        height: 100vh;
        width: 100%;
    }
</style>
